<div class="navbar-buttons">
  <a class="button fancy-button" routerLink="/home" routerLinkActive="active" title="Go to Home">
    <i class="material-icons">home</i>
    <span>Home</span>
  </a>
  <a class="button fancy-button" routerLink="/questions" routerLinkActive="active" title="Start Questionnaire">
    <i class="material-icons">assignment</i>
    <span>Questions</span>
  </a>
  <a class="button fancy-button" routerLink="/results" routerLinkActive="active" title="View Results">
    <i class="material-icons">list</i>
    <span>Results</span>
  </a>
</div>